import { $api } from "@/lib/api";

const SERVICE_BANNER_POLL_INTERVAL = 60_000;

/**
 * Polls the global outage banner (P-2469).
 *
 * A dedicated endpoint rather than piggybacking on `/users/me`: the point of an
 * outage notice is that it lands now, and `/users/me` would leave an idle tab
 * blank until the user interacted.
 *
 * `refetchIntervalInBackground` stays at its default `false`, so hidden tabs
 * stop polling; react-query's default `refetchOnWindowFocus` gives an immediate
 * refresh when the user comes back.
 */
export const useServiceBanner = () =>
  $api.useQuery(
    "get",
    "/v1/service-banner",
    {},
    // `retry: false` because the app-wide QueryClient is a bare
    // `new QueryClient()`, so this poll would otherwise inherit `retry: 3` and
    // fire 4 requests per tick per open tab during exactly the incident the
    // banner exists to announce. The next tick is 60s away, so it self-heals.
    { refetchInterval: SERVICE_BANNER_POLL_INTERVAL, retry: false },
  );
